import * as React from "react";
import {Label} from "bloomer";
import InputWarning from "../../../../../elements/InputWarning";

interface ITextExtractionModelInputState {
    file: any;
    fileErrorMessage: string;
}

class TextExtractionModelInput extends React.Component<{}, ITextExtractionModelInputState> {
    public fileInputRef: any = null;
    public fileInputStyle = {
        width: '100%'
    };
    public ALLOWED_FILE_TYPES: any = ['image/jpeg', 'image/png', 'application/pdf'];
    public ALLOWED_FILE_TYPES_STR: string = this.ALLOWED_FILE_TYPES.join(',');

    public constructor(props: {}) {
        super(props);
        this.state = {
            file: null,
            fileErrorMessage: ""
        };
    }

    public handleFileChange = (e: any) => {
        this.setState({
            fileErrorMessage: ""
        });

        const file = e.target.files[0];
        if (file) {
            if (this.ALLOWED_FILE_TYPES.includes(file.type)) {
                this.setState({
                    file
                });
            } else {
                this.setState({
                    file: null,
                    fileErrorMessage: "The model only accepts JPEG, PNG or PDF format files."
                });
            }
        }
    };

    public validateForm = () => {
        if (this.state.fileErrorMessage) {
            return false;
        }

        if (!this.state.file) {
            this.setState({
                fileErrorMessage: "Please select Image or PDF file."
            });
            return false;
        }

        return true;
    };

    public getFormData = (modelNamePrefix: string) => {
        const formData = new FormData();
        formData.append(`${modelNamePrefix}.file`, this.state.file);
        return formData;
    };

    public resetForm = () => {
        this.setState({
            file: "",
            fileErrorMessage: ""
        });
        if (this.fileInputRef) {
            this.fileInputRef.value = "";
        }
    };

    public render() {
        return (
            <React.Fragment>
                        <Label>Select Image or PDF File:</Label>
                        <input
                            ref={(el) => this.fileInputRef = el}
                            type="file"
                            accept={this.ALLOWED_FILE_TYPES_STR}
                            onChange={this.handleFileChange}
                            style={this.fileInputStyle}
                        />
                        {
                            this.state.fileErrorMessage && <div>
                                <InputWarning>{this.state.fileErrorMessage}</InputWarning>
                            </div>
                        }
            </React.Fragment>
        );
    }
}

export default TextExtractionModelInput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/input/TextExtraction/TextExtractionModelInput.tsx